<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="配置名称：">
            <el-input v-model="query.name" placeholder="请输入配置名称" clearable size="small" />
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="query.isEnable" placeholder="请选择" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="启用" :value="1"></el-option>
              <el-option label="禁用" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column label="配置名称" prop="name" align="center" width="200" fixed="left" />
        <el-table-column label="配置内容" prop="content" align="center" width="400">
          <template slot-scope="{row}">
            <span v-if="row.code === 'order_is_open_remark'">{{+row.content?'允许备注':'不允许备注'}}</span>
            <span v-else-if="row.code === 'meetFeeReundMethod'">{{row.content === '10'?'原路退回':'余额退回'}}</span>
            <span v-else-if="row.code === 'setCourse' || row.code === 'homeRecommendedCourse' || row.code === 'onlineSituationalPracticeAnswer' || row.code === 'SituationalPracticeAnswer'">{{+row.content?'是':'否'}}</span>
            <span v-else-if="row.code === 'custFranchiseDescL7' || row.code === 'custFranchiseDescL6' || row.code === 'PrivacyAgreement'|| row.code === 'ServiceAgreement' || row.code === 'meetingPingZhengJiaoCheng'">{{row.content?'图文配置（具体点击编辑查看）':''}}</span>
            <span v-else-if="row.code === 'after_sales_return_address'">收货人：{{row.content}}<br />收货地址：{{row.content1}}</span>
            <span v-else-if="row.code === 'coursewarePictureWatermark' || row.code === 'HomeLiveBigPicture'">
              <el-image style="width: 50px; height: 50px" :src="row.content" :preview-src-list="[row.content]"></el-image>
            </span>
            <span v-else-if="row.code === 'MarketingPotentialShare'">
              <template v-if="row.content">
                <el-image
                  v-for="(img, imgIndex) in parseImages(row.content)"
                  :key="imgIndex"
                  style="width: 50px; height: 50px; margin-right: 5px;"
                  :src="img"
                  :preview-src-list="parseImages(row.content)"
                ></el-image>
              </template>
            </span>
            <span v-else-if="row.code === 'WatermarkPosition'">
              {{watermarkPositionTxt[row.content]}}
            </span>
            <span v-else-if="row.code === 'upyanxiubansendgood' || row.code === 'uptiyanbansendgood' || row.code === 'tyupxybansendgood'">
              <span v-if="row.content"> {{JSON.parse(row.content).goodsCode}}-{{JSON.parse(row.content).name}}-{{JSON.parse(row.content).spec || '无规格值'}}</span>
            </span>
            <span v-else-if="row.code === 'meetingBaoMingZhuanPiao'">{{+row.content?'允许转票':'不允许转票'}}</span>
            <span v-else-if="row.code === 'APPIsStartXianxia'">{{+row.content?'允许线下报名':'不允许线下报名'}}</span>
            <span v-else-if="row.code === 'changAddRegistrationGift'">{{+row.content?'自动发货':'下单客户手动发货'}}</span>
            <span v-else>{{row.content}}</span>
          </template>
        </el-table-column>
        <el-table-column label="单位" prop="content1" align="center">
          <template slot-scope="{row}">
            <span v-if="row.code != 'after_sales_return_address'">{{row.content1}}</span>
          </template>
        </el-table-column>
        <el-table-column label="修改时间" prop="operatedTime" sortable="custom" align="center" width="160" />
        <el-table-column label="状态" prop="isEnable" align="center">
          <template slot-scope="{row}">
            <el-switch v-model="row.isEnable" :active-value="true" :inactive-value="false" @change="changeSwitch(row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作人" prop="operatedName" align="center" />
        <el-table-column label="操作" align="center" width="160" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row)">编辑</el-button>
            <el-button type="text" @click="handleLog(row)">日志记录</el-button>
            <!-- <el-button type="text" @click="handleDeleteSingle(row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->

    <basics-add ref="basicsAdd" @created="doQueryList({})" />
  </div>
</template>

<script>
import basicsAdd from './add'
import sysDataconstantApi from '@/api/config/sysDataconstant'
import Pagination from '@/components/Pagination'

export default {
  components: {
    Pagination,
    basicsAdd
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        isDisplay: 1
      },
      selectItems: [],
      watermarkPositionTxt: ['', '左上', '中上', '右上', '左中', '居中', '右中', '左下', '中下', '右下']
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    /**
     * 解析图片列表（支持JSON数组或逗号分隔的字符串）
     */
    parseImages(content) {
      if (!content) return [];
      try {
        // 尝试解析为 JSON 数组
        const parsed = JSON.parse(content);
        if (Array.isArray(parsed)) {
          return parsed;
        }
        return [content];
      } catch (e) {
        // 如果不是 JSON，尝试按逗号分隔
        if (content.includes(',')) {
          return content.split(',').map(s => s.trim()).filter(Boolean);
        }
        // 单个图片
        return [content];
      }
    },
    handleFilter() {
      this.query = {}
      this.query.isDisplay = 1
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.listLoading = true
      return sysDataconstantApi.fetchBatchCode(this.query).then(({ data }) => {
        this.list = data.list
        this.total = data.total
      }).finally(() => {
        this.listLoading = false
      })
    },
    changeSwitch(row) {
      sysDataconstantApi.setIsEnable({ id: row.id, isEnable: row.isEnable }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.$refs.basicsAdd.handleCreate()
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$refs.basicsShow.handleShow(row.id)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.basicsAdd.handleUpdate(row)
    },
    handleLog(row) {
      this.$router.push("/log/log?type=100&id=" + row.id);
    }
  }
}
</script>
